<template>
    <div class="information-datails-box">
        <el-row>
            <el-col :xs="{span: 20, offset: 2}" :sm="{span: 20, offset: 2}" :md="{span: 16, offset: 4}"
                    :lg="{span: 16, offset: 4}" :xl="{span: 16, offset: 4}">
                <div class="information-datails-next">
                    <!--                    <a href="javascript:;" @click="afterNewsC">上一篇: {{afterNews.title}}</a>-->
                    <a href="javascript:;" @click="afterNewsC">上一篇: {{afterNews.title}}</a>
                    <!--                    <a href="javascript:;" @click="preNewsC">下一篇: {{preNews.title}}</a>-->
                    <a href="javascript:;" @click="preNewsC">下一篇: {{preNews.title}}</a>
                </div>
                <!--                <div v-html="newsD"></div>-->
                <new01 v-if="newsId==-1"></new01>
                <new02 v-if="newsId==-2"></new02>
                <new03 v-if="newsId==-3"></new03>
                <div v-if="newsId>0" v-html="news.content"></div>
                <div @click="newsMore" class="information-datails-more">更多资讯>></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import new01 from './replace/new01'
import new02 from './replace/new02'
import new03 from './replace/new03'

export default {
  name: 'informationDetails',
  components: {new01, new02, new03},
  data() {
    return {
      afterNews: {title: '索康与广东省医学会整形外科学分会学术会议达成独家合作', id: -1},
      newsD: [{title: '索康与广东省医学会整形外科学分会学术会议达成独家合作', id: -1},
        {title: '巅峰论鼻，索康协办广州鼻整形精英学术峰会', id: -2},
        {title: '索康热衷公益，全力协办武汉唇裂鼻修复研讨会', id: -3}],
      news: '',
      preNews: {title: '索康与广东省医学会整形外科学分会学术会议达成独家合作', id: -1},
      newsId: ''
    }
  },
  created() {
    // if (this.$store.getters.newsId){
    //   this.$store.state.news.newsId = this.$route.query.newsId
    // }
    // this.getNews(this.$route.query.newsId)
    this.newsId = this.$route.query.newsId
    if (this.newsId > 0) {
      // console.log(this.$store.state.news.newsList)
      let newsList = this.$store.state.news.newsList
      for (let i = 0; i < newsList.length; i++) {
        if (this.$route.query.newsId == newsList[i].id) {
          this.news=newsList[i]
          // console.log(newsList[i])
          if (i == 0) {
            this.afterNews = newsList[1]
            this.preNews = newsList[2]
          } else if (i == 1) {
            this.afterNews = newsList[2]
            this.preNews = newsList[0]
          } else if (i == 2) {
            this.afterNews = newsList[0]
            this.preNews = newsList[1]
          }
        }
      }
    }else {
      if (this.$route.query.newsId == -1) {
        this.afterNews = this.newsD[1]
        this.preNews = this.newsD[2]
      } else if (this.$route.query.newsId == -2) {
        this.afterNews = this.newsD[2]
        this.preNews = this.newsD[0]
      } else if (this.$route.query.newsId == -3) {
        this.afterNews = this.newsD[0]
        this.preNews = this.newsD[1]
      }
    }

  },
  methods: {
    newsMore() {
      this.$router.push({  //核心语句
        path: '/information/list'   //跳转的路径
      })
    },

    afterNewsC() {
      this.$router.push({  //核心语句
        path: '/information/details',
        query: {newsId: this.afterNews.id}
      })
      this.newsId = this.afterNews.id

      if (this.afterNews.id > 0) {
        // console.log(this.$store.state.news.newsList)
        let newsList = this.$store.state.news.newsList
        let afterId=this.afterNews.id
        for (let i = 0; i < newsList.length; i++) {
          if ( afterId == newsList[i].id) {
            this.news=newsList[i]
            if (i == 0) {
              this.afterNews = newsList[1]
              this.preNews = newsList[2]
            } else if (i == 1) {
              this.afterNews = newsList[2]
              this.preNews = newsList[0]
            } else if (i == 2) {
              this.afterNews = newsList[0]
              this.preNews = newsList[1]
            }
          }
        }
      }else {
        if (this.afterNews.id == 1) {
          this.afterNews = this.newsD[1]
          this.preNews = this.newsD[2]
        } else if (this.afterNews.id == 2) {
          this.afterNews = this.newsD[2]
          this.preNews = this.newsD[0]
        } else {
          this.afterNews = this.newsD[0]
          this.preNews = this.newsD[1]
        }
      }
    },

    preNewsC() {
      // this.getNews(this.preNews.id)
      this.$router.push({  //核心语句
        path: '/information/details',
        query: {newsId: this.preNews.id}
      })
      this.newsId = this.preNews.id
      if (this.preNews.id > 0) {
        // console.log(this.$store.state.news.newsList)
        let newsList = this.$store.state.news.newsList
        let prenewsId=this.preNews.id
        for (let i = 0; i < newsList.length; i++) {
          if ( prenewsId == newsList[i].id) {
            this.news=newsList[i]
            if (i == 0) {
              this.afterNews = newsList[1]
              this.preNews = newsList[2]
            } else if (i == 1) {
              this.afterNews = newsList[2]
              this.preNews = newsList[0]
            } else if (i == 2) {
              this.afterNews = newsList[0]
              this.preNews = newsList[1]
            }
          }
        }
      }else {

        if (this.preNews.id == 1) {
          this.afterNews = this.newsD[1]
          this.preNews = this.newsD[2]
        } else if (this.preNews.id == 2) {
          this.afterNews = this.newsD[2]
          this.preNews = this.newsD[0]
        } else {
          this.afterNews = this.newsD[0]
          this.preNews = this.newsD[1]
        }
      }
    },

    getNews(newsId) {
      this.$store.dispatch('news/findNewsD', {newsId: newsId}).then((resolve) => {
        this.newsD = resolve.news.content
        this.news = resolve.news
        this.afterNews = resolve.afterNews
        this.preNews = resolve.preNews
        // this.$store.state.news.newsId = resolve.news.id
      })
    }
  }
}
</script>

<style scoped>
    a {
        text-decoration: none;
        color: #430098;
    }

    .information-datails-box {
        font-size: 14px;
        font-family: SY-Light;
    }

    .information-datails-next {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        color: #430098;
        height: 60px;
        border-bottom: 1px solid #7a7a7a;
        margin-bottom: 50px;
    }

    .information-datails-more {
        height: 45px;
        background-color: #f1f1f1;
        color: #430098;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 50px 0;
    }
</style>
